import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthProvider";
import { loginUser } from "../services/userService";
import { Spinner } from "react-bootstrap";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authErrorMsg, setAuthErrorMsg] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const loggedInUser = await loginUser(email, password);
    setLoading(false);
    if (loggedInUser && loggedInUser?.id) {
      login(loggedInUser);
      navigate("/dashboard");
    } else {
      handleAuthErrorMsg(loggedInUser.message);
    }
  };

  const handleAuthErrorMsg = (errorMsg) => {
    setAuthErrorMsg(errorMsg);
    setTimeout(() => {
      setAuthErrorMsg("");
    }, 3000);
  };

  return (
    <div className="flex h-screen">
      {/* Left Column - Title */}
      <div className="hidden md:flex flex-col justify-center items-center w-1/2 text-white p-8" style={{ background: 'linear-gradient(135deg, #00428a 0%, #55c900 100%)' }}>
        <div className="flex flex-col items-center text-center max-w-md">
          <img
            src="/assets/images/bhit-logo.png"
            alt="BHIT Logo"
            className="h-16 w-auto mb-6"
          />
          <h1 className="text-3xl font-bold mb-4">Welcome Back!</h1>
          <p className="text-xl text-gray-200 mb-6">BHIT Training Portal</p>
          
          <div className="space-y-4 text-left">
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Access your personalized learning dashboard</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Track your progress and assignments</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Connect with tutors and fellow students</p>
            </div>
            <div className="flex items-start space-x-3">
              <div className="w-2 h-2 rounded-full mt-2" style={{ backgroundColor: '#55c900' }}></div>
              <p className="text-gray-200 mb-0">Manage your courses and schedules</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Column - Login Form */}
      <div className="flex flex-col justify-center items-center w-full md:w-1/2 bg-gray-50 dark:bg-gray-900 p-6">
        {/* Back to Home Button */}
        <div className="w-full max-w-sm mb-4">
          <button
            onClick={() => navigate('/')}
            className="flex items-center text-sm font-medium px-4 py-2 rounded-lg transition-all duration-300 hover:shadow-md"
            style={{ 
              color: '#00428a',
              backgroundColor: 'white',
              border: '1px solid #e5e7eb'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f9fafb';
              e.target.style.borderColor = '#00428a';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.borderColor = '#e5e7eb';
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
            </svg>
            Back to Home
          </button>
        </div>
        <div className="w-full max-w-sm bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
          <div className="flex flex-col items-center mb-6">
            {/* <img
              src="/assets/images/bhit-logo.png"
              alt="BHIT Logo"
              className="h-12 w-auto mb-3 dark:filter dark:brightness-0 dark:invert"
            /> */}
            <h2 className="text-2xl font-bold text-center text-gray-800 dark:text-gray-200">
              Login
            </h2>
          </div>
          {authErrorMsg && (
            <div className="mb-4 text-red-600 text-sm text-center bg-red-100 p-2 rounded">
              {authErrorMsg}
            </div>
          )}
          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Email <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                placeholder="Enter your email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-white"
                style={{ borderColor: '#00428a' }}
                onFocus={(e) => e.target.style.borderColor = '#55c900'}
                onBlur={(e) => e.target.style.borderColor = '#00428a'}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                Password <span className="text-red-500">*</span>
              </label>
              <input
                type="password"
                placeholder="Enter your password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm dark:bg-gray-700 dark:text-white"
                style={{ borderColor: '#00428a' }}
                onFocus={(e) => e.target.style.borderColor = '#55c900'}
                onBlur={(e) => e.target.style.borderColor = '#00428a'}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full text-white py-2 rounded-lg transition disabled:opacity-50"
              style={{ backgroundColor: '#55c900' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#48b000'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#55c900'}
            >
              {loading ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    role="status"
                    className="text-white"
                  />
                  <span className="ml-2">Loading...</span>
                </>
              ) : (
                "Sign In"
              )}
            </button>
          </form>

          <p className="my-4 text-center text-sm text-gray-600 dark:text-gray-400">
            Trouble logging in?{" "}
            <a
              href="/reset-password"
              style={{ color: '#00428a' }}
              className="hover:underline"
            >
              Reset Password
            </a>
          </p>
          <button
            onClick={() => navigate("/signup")}
            type="button"
            className="w-full bg-white border-2 border-solid py-1.5 rounded-lg transition"
            style={{ borderColor: '#00428a', color: '#00428a' }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#00428a'; e.target.style.color = 'white'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = 'white'; e.target.style.color = '#00428a'; }}
          >
            Sign Up
          </button>
        </div>
      </div>
    </div>
  );
}
